// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ResponsiveAddress_wrapper__3anm5","firstPart":"ResponsiveAddress_firstPart__IRfrZ"};